<template>
  <section class="declarations-section">
    <Preloader v-if="isLoading || !iframe.loaded" />
    <div
      v-show="iframe.loaded"
      class="declarations-wrapper"
      :class="[`bg-${$route.meta.background}`]"
    >
      <transition name="fade-animation" appear>
        <iframe
          ref="iframe"
          class="declarations-iframe"
          @load="onIframeLoaded"
          v-show="iframe.loaded"
          :src="declarationRoute"
        />
      </transition>
    </div>
  </section>
</template>

<script>
import {
  mapState, mapActions, mapGetters, mapMutations,
} from 'vuex';
import Preloader from '@/components/Loader.vue';

export default {
  name: 'Declarations',
  components: {
    Preloader,
  },
  data() {
    return {
      iframe: {
        loaded: false,
      },
    };
  },
  computed: {
    ...mapState('students', ['students', 'student']),
    ...mapState('layout', ['isLoading']),
    ...mapGetters('auth', ['isFullAccess']),
    declarationRoute() {
      let baseRoute;
      if (process.env.VUE_APP_ENVIRONMENT === 'production') {
        baseRoute = process.env.VUE_APP_DECLARATIONS_APP_PUBLIC_URL;
      } else {
        baseRoute = process.env.VUE_APP_DECLARATIONS_APP_TEST_PUBLIC_URL;
      }

      if (this.student && this.student.declarationCode) {
        return `${baseRoute}/${this.student.declarationCode}`;
      }

      return baseRoute;
    },
  },

  methods: {
    ...mapActions('auth', ['getRefundData', 'updateRefundData']),
    ...mapMutations('auth', ['setCurrentProfile', 'setAccess']),
    onIframeLoaded() {
      setTimeout(() => {
        this.iframe.loaded = true;
      }, 1000); // 1000 milliseconds = 1 second
    },
  },

  async created() {
    this.$store.commit('layout/finishLoading');
  },

  mounted() {
    document.body.classList.add('hide-class-list');
    document.body.classList.add('dont-show-class-list');
    window.addEventListener('message', this.handleIframeHeightMessage);
    setTimeout(() => {
      this.$store.commit('layout/finishLoading');
    }, 300);
  },
  beforeDestroy() {
    document.body.classList.remove('dont-show-class-list');
    window.removeEventListener('message', this.handleIframeHeightMessage);
  },
};
</script>

<style lang="scss" scoped>
.declarations-section {
  margin-left: auto;
  min-height: 100%;
  position: relative;
  z-index: 1;
  @media screen and (min-width: 768px) {
    width: calc(100% - 312px);
    padding-top: 40px;
    padding-bottom: 40px;
    padding-left: 80px;
    padding-right: 80px;
  }

  .declarations-wrapper {
    @apply flex flex-col justify-center items-center;
    background-color: #ffffff;
    padding-top: 80px;
    @media screen and (min-width: 768px) {
      padding: 8px;
    }
  }

  .declarations-iframe {
    width: 100%;
    height: calc(100vh - 80px - 67px);
    transition: opacity 0.5s ease;
    @media screen and (min-width: 768px) {
      height: calc(100vh - 80px - 16px);
    }
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s ease;
}

.fade-enter,
.fade-leave-to,
.fade-leave-active {
  opacity: 1;
}
</style>
